import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Form, Row, Table } from "react-bootstrap";
import LocationLists from "./components/LocationLists";
import { ActionButton, CustomCheckbox, ScreenNav } from "../../components";
import { compose } from "redux";
import { connect } from "react-redux";
import { authActions } from "../../state/ducks/auth";
import { userActions } from "../../state/ducks/user";
import { withTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import ModalInfo from "./components/ModalInfo";
import { URL, API_VERSION_MB } from "../../config/constants";

const LocationbyZone = (props) => {
   console.log("propssssssssssssssssssssssssssssssssssssssss:", props);
  const [accdata, setAccData] = useState([]);
  const [pricingData, setPricingData] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [checkboxValue, setCheckboxValue] = useState(false);
  const [numRows, setNumRows] = useState(0);
  const [rows, setRows] = useState([]);
  const [checkedValues, setCheckedValues] = useState([]);
  const [addedCps, setAddedCps] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [zipCodesRows, setzipCodesRows] = useState([]);

  const companyName = props.history.location.state.companyName;
  const prueba = props.history.location.state.rows;
  const { t, history } = props;
  const value = JSON.parse(localStorage.getItem("persist:root"));
  const valuetoken = JSON.parse(value.auth);
  const token = valuetoken.userData.token;
  const { inputValues } = props.location.state;

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  });
  const config = { method: "GET", headers };

  // Fetch localities
  useEffect(() => {
    fetch(`${URL}${API_VERSION_MB}/api/pricings/localities`, config)
      .then((res) => res.json())
      .then((data) => setAccData(data.data));
  }, []);

  function handleCpChange(event) {
    setSelectedValue(event.currentTarget.value);
  }

  function addFilas(num) {
    setSelectedValue(num);
    // Aquí no usamos setInputValues porque lo tenías undefined antes
  }

  // Generar locationLists dinámico
  const locationLists = [];
  for (let i = 0; i < prueba; i++) {
    locationLists.push(
      <Col key={i} xs={12} sm={6} md={4} lg={3}>
        <LocationLists
          checkedValues={checkedValues}
          setCheckedValues={setCheckedValues} // ✅ ahora sí está pasando
          addedCps={addedCps}
          setAddedCps={setAddedCps}
          zoneName={inputValues[i] ? inputValues[i].value : ""}
          accdata={accdata}
          rows={rows}
          zipCodesRows={zipCodesRows}
          checkboxAllValue={checkboxValue}
          t={t}
          setRows={setRows}
          setzipCodesRows={setzipCodesRows}
          setSelectedValues={setSelectedValues}
          setCheckboxValue={setCheckboxValue}
          setSelectedProvince={setSelectedProvince}
        />
      </Col>
    );
  }

  // Table rows dinámicos
  useEffect(() => {
    const newRows = [];
    for (let i = 0; i < numRows; i++) {
      const key = uuidv4();
      newRows.push(
        <tr style={{ display: "table", width: "100%" }} key={key}>
          <td
            style={{ textAlign: "center", width: "75%", tableLayout: "fixed" }}
          >
            {selectedValue}
          </td>
          <td
            style={{ textAlign: "center", width: "25%", tableLayout: "fixed" }}
          >
            <CustomCheckbox
              name={`checkbox ${key}`}
              value={key}
              id={key}
              onChange={(event) => handleCheckboxChange(event, key)}
              checked={checkedValues.includes(selectedValue)}
            />
          </td>
        </tr>
      );
    }
    setRows((prev) => prev.concat(newRows));
    setSelectedValues((prev) => prev.concat(selectedValue));
  }, [numRows, selectedValue]);

  const handleCheckboxChange = (event, key) => {
    const checked = event.target.checked;
    if (checked) {
      setCheckedValues((prev) => prev.concat(selectedValue));
    } else {
      setCheckedValues((prev) =>
        prev.filter((val) => val !== selectedValue)
      );
    }
  };

  // Provinces
  const provinces = [...new Map(accdata.map((item) => [item.province_name, item])).values()];
  const provincesOptions = provinces.map((p, idx) => (
    <option key={idx} value={p.province_name}>
      {p.province_name}
    </option>
  ));

  const handleProvinceChange = (event) => {
    setzipCodesRows([]);
    setSelectedProvince(event.target.value);
  };

  const getZipCodesForProvince = (provincescp, selectedProvince) => {
    return provincescp
      .filter((p) => p.province_name === selectedProvince)
      .map((p) => `${p.zip_code} - ${p.locality_name}`);
  };

  const provincescp = accdata.map((elem) => ({
    province_name: elem.province_name,
    zip_code: elem.zip_code,
    locality_name: elem.locality_name,
  }));
  const zipCodes = getZipCodesForProvince(provincescp, selectedProvince);

  useEffect(() => {
    setzipCodesRows(
      zipCodes.map((zip, idx) => (
        <tr
          style={{ display: "table", width: "100%" }}
          key={`${selectedProvince}-${zip}-${idx}`}
        >
          <td style={{ textAlign: "center", width: "75%" }}>{zip}</td>
          <td style={{ textAlign: "center", width: "25%" }}>
            <CustomCheckbox
              value={idx}
              name={zip}
              id={`${idx}-checkbox`}
              onChange={(event) => {
                const val = event.target.checked;
                if (val) setCheckedValues((prev) => prev.concat(zip));
                else
                  setCheckedValues((prev) =>
                    prev.filter((v) => v !== zip)
                  );
              }}
              checked={checkedValues.includes(zip)}
            />
          </td>
        </tr>
      ))
    );
  }, [selectedProvince, checkedValues]);

  // // POST hardcodeado (queda igual)
  // useEffect(() => {
  //   const dataPricing = {
  //     method: "POST",
  //     headers: headers,
  //     body: JSON.stringify({
  //       name: "TARIFARIO NUEVO2",
  //       validSince: "2023-02-27T18:06:22.438Z",
  //       areas: [
  //         {
  //           name: "AMBA",
  //           finalKilogramValue: 100,
  //           increasedWeight: 20,
  //           startingTariffPrice: 1100,
  //           tariffPriceIncrease: 600,
  //           insurance: 700,
  //           homeDelivery: 745,
  //           homeWithdrawal: 300,
  //           others: 800,
  //           additionalPriceIncrease: 110,
  //           localities: [
  //             {
  //               zipCode: 1888,
  //               name: "FLORENCIO VARELA",
  //             },
  //           ],
  //         },
  //       ],
  //       accountId: 1,
  //     }),
  //   };
  //   fetch("http://localhost:8081/v1/api/pricings/", dataPricing)
  //     .then((res) => res.json())
  //     .then((data) => setPricingData(data));
  // }, []);

const handleSubmitPricing = (useRealData = true) => {
  let dataPricing = {
    name: "TARIFARIO NUEVO2",
    validSince: "2023-02-27T18:06:22.438Z",
    areas: [
      {
        name: "AMBA",
        finalKilogramValue: 100,
        increasedWeight: 20,
        startingTariffPrice: 1100,
        tariffPriceIncrease: 600,
        insurance: 700,
        homeDelivery: 745,
        homeWithdrawal: 300,
        others: 800,
        additionalPriceIncrease: 110,
        localities: [
          {
            zipCode: 1888,
            name: "FLORENCIO VARELA",
          },
        ],
      },
    ],
    accountId: 1,
  };

  if (useRealData && inputValues?.length > 0) {
    dataPricing = {
      name: inputValues[0]?.name,
      validSince:
        props.location.state.validSince || new Date().toISOString(),
      areas: inputValues.map((z, i) => ({
        name: z.name || `ZONA ${i + 1}`,
        finalKilogramValue: Number(z.finalKilogramValue) || 0,
        increasedWeight: Number(z.increasedWeight) || 0,
        startingTariffPrice: Number(z.startingTariffPrice) || 0,
        tariffPriceIncrease: Number(z.tariffPriceIncrease) || 0,
        insurance: Number(z.insurance) || 0,
        homeDelivery: Number(z.homeDelivery) || 0,
        homeWithdrawal: Number(z.homeWithdrawal) || 0,
        others: Number(z.others) || 0,
        additionalPriceIncrease: Number(z.additionalPriceIncrease) || 0,
        localities: addedCps.map((item) => ({
          zipCode: item.cp,
          name: item.locality,
        })),
      })),
      accountId: 1,
    };
  }

  fetch(`${URL}${API_VERSION_MB}/api/pricings/`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(dataPricing),
    })
      .then(async (response) => {
        const data = await response.json();

        if (!response.ok || data.success === false) {
          // 🚫 Error lógico del backend
          throw new Error(data.data || "Error al crear el tarifario");
        }

        // ✅ Éxito
        setPricingData(data);
        console.log("POST exitoso:", data);
        alert("✅ Tarifario cargado correctamente");

        setTimeout(() => {
          props.history.push("/");
        }, 1500);
      })
      .catch((err) => {
        console.error("Error POST:", err);
        alert("❌ No se pudo crear el tarifario: " + err.message);
      });
  };

  function handleBack() {
    props.history.goBack();
  }

  return (
    <Container fluid style={{ marginBottom: "3rem" }}>
      <Row style={{ justifyContent: "flex-start", marginTop: "3rem" }}>
        <Col xs={9} sm={8}>
          <h2>
            {t("locationByZone.mainTitle")} - {companyName}
          </h2>
        </Col>
      </Row>

      <Row style={{ justifyContent: "flex-start", marginTop: "3rem" }}>
        <Col xs={12} sm={8}>
          <ScreenNav
            history={history}
            previousPage={t("locationByZone.previousPage")}
            currentPage={t("locationByZone.currentPage")}
          />
          <h5>{t("locationByZone.subTitle")}</h5>
        </Col>
      </Row>

      <Row style={{ justifyContent: "flex-start", marginTop: "0.5rem" }}>
        <Col xs={10} sm={6} md={6} lg={2}>
          <ModalInfo />
        </Col>
      </Row>

      <Container fluid>
        <Row style={{ justifyContent: "center", marginTop: "5rem" }}>
          {locationLists}
        </Row>
      </Container>

      <Container fluid>
        <Row style={{ justifyContent: "center", alignContent: "center" }}>
          <Col xs={12} lg={6}>
            <div className="mt-4">
              <Form>
                <Table style={{ overflowX: "scroll" }} bordered hover>
                  <thead style={{ display: "block" }}>
                    <tr
                      style={{ display: "table", width: "100%" }}
                      className="trclass"
                    >
                      <th className="th-custom">
                        {t("locationByZone.tableTitle1")}
                        <select
                          className="select"
                          onChange={(event) => {
                            handleCpChange(event);
                            addFilas(1);
                          }}
                        >
                          <option value="">
                            {t("locationByZone.defaultOptionValue2")}
                          </option>
                          {accdata.map((cp, index) => (
                            <option
                              key={index}
                              value={`${cp.zip_code} - ${cp.locality_name}`}
                            >
                              {cp.zip_code} - {cp.locality_name}
                            </option>
                          ))}
                        </select>
                      </th>
                      <th className="th-custom">
                        {t("locationByZone.tableTitle2")}
                        <select
                          className="select"
                          onChange={handleProvinceChange}
                          value={selectedProvince}
                        >
                          <option value="">
                            {t("locationByZone.defaultOptionValue1")}
                          </option>
                          {provincesOptions}
                        </select>
                      </th>
                      <th style={{ width: "25%" }}>
                        {t("locationByZone.tableTitle3")}
                        <br />
                        <br />
                        <h6 className="select-all">
                          {t("locationByZone.tableTitle4")}
                          <input
                            type="checkbox"
                            className="check-all"
                            checked={checkboxValue}
                            onChange={(event) => {
                              setCheckboxValue(event.target.checked);
                              if (!event.target.checked) setCheckedValues([]);
                            }}
                          />
                        </h6>
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      display: "block",
                      width: "100%",
                      overflowY: "auto",
                      maxHeight: "40vh",
                    }}
                  >
                    {rows}
                    {zipCodesRows}
                  </tbody>
                </Table>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <Row style={{ width: "100%", justifyContent: "flex-end" }}>
        <Col style={{ margin: "2rem", justifyContent: "left" }} xs={11} sm={6} md={3} className="p-0">
          <ActionButton type="submit" width="90" onClick={handleSubmitPricing}>
            {t("locationByZone.actionButton1")}
          </ActionButton>
          <ActionButton secondary width="90" onClick={() => handleSubmitPricing(true)}>
            {t("locationByZone.actionButton2")}
          </ActionButton>
        </Col>
      </Row>
    </Container>
  );
};

const mapDispatchToProps = ({ auth, user }) => ({ auth, user });

export default compose(
  connect(mapDispatchToProps, { ...authActions, ...userActions }),
  withTranslation()
)(LocationbyZone);
